import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { Variant } from './enums/variant.js';
import { Size } from './enums/size.js';
import { badge as badgeStyles } from './styles/badge.js';
let ViedocBadge = class ViedocBadge extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = Variant.Primary;
        this.size = Size.Small;
    }
    render() {
        const classNames = classMap({
            badge: true,
            [`badge--${this.size}`]: true,
            [`badge--${this.variant}`]: true,
        });
        return html `<div class=${classNames}>
      ${when(this.prefixIcon, () => html `<viedoc-icon
            class="badge__prefix"
            name=${this.prefixIcon}
            part="prefix-icon"
          ></viedoc-icon>`)}
      <slot></slot>
    </div>`;
    }
};
ViedocBadge.styles = [badgeStyles];
__decorate([
    property({ type: String, attribute: 'prefix-icon' })
], ViedocBadge.prototype, "prefixIcon", void 0);
__decorate([
    property({ type: String })
], ViedocBadge.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], ViedocBadge.prototype, "size", void 0);
ViedocBadge = __decorate([
    customElement('viedoc-badge')
], ViedocBadge);
export { ViedocBadge };
